module.exports = __webpack_public_path__ + "img/SKLB-Incidencias 2.c33f22f5.png";